import { ReduxAsyncActionsService } from '../../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../../types/ReduxAsyncActions.types';
import { GET_AD_ACCOUNTS_STATUS } from '../../actions/getAdAccountsStatus.action';
import { GET_GOOGLE_AUTHENTICATION_URL } from '../actions';
import { INIT_STATE } from './GoogleAds.constants';
import type { GoogleAdsState } from './GoogleAds.types';
import type { GoogleAction } from './actions';
import { GET_GOOGLE_ADS_AD_ACCOUNTS } from './actions/getAdAccounts.action';
import { VALIDATE_GOOGLE_ADS_LINK_IDS } from './actions/validateLinkIds.action';

function handler(state: WrappedReducer<GoogleAdsState>, action: GoogleAction): WrappedReducer<GoogleAdsState> {
  switch (action.type) {
    case GET_GOOGLE_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    case GET_GOOGLE_ADS_AD_ACCOUNTS.response:
      const { accounts } = action.data;
      return {
        ...state,
        adAccounts: accounts,
        loading: false,
      };

    case VALIDATE_GOOGLE_ADS_LINK_IDS.request:
      return {
        ...state,
        validating: true,
      };

    case VALIDATE_GOOGLE_ADS_LINK_IDS.response:
      return {
        ...state,
        linkIdValidationResult: action.data,
        loading: false,
        validating: false,
      };

    case GET_AD_ACCOUNTS_STATUS.response:
      const { a_google_adwords } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_google_adwords,
        loading: false,
      };

    default:
      return state;
  }
}

const GoogleMarketingPlatform = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_GOOGLE_AUTHENTICATION_URL, GET_GOOGLE_ADS_AD_ACCOUNTS, GET_AD_ACCOUNTS_STATUS],
  error: [GET_GOOGLE_AUTHENTICATION_URL, GET_GOOGLE_ADS_AD_ACCOUNTS, VALIDATE_GOOGLE_ADS_LINK_IDS, GET_AD_ACCOUNTS_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default GoogleMarketingPlatform;
